export const entity_language = {
    entity: {
        user: 'Utenti',
        user_group: 'Gruppi',
        log: 'Log di sistema',
        user_entity_saved_filters: 'Filtri salvati',
        user_entity_preferences: 'Preferenze entità',

        customer_order: 'Ordini cliente',
        gyv_customer: 'Clienti',
        gyv_customer_active: 'Clienti attivi',
        gyv_customer_unsolved: 'Clienti insoluti',
        gyv_order: 'Ordini',
        gyv_customer_history: 'Storico acquisti clienti',
        gyv_customer_rimanenze: 'Righe da evadere',
        gyv_item: 'Articoli',
        gyv_item_picker: 'Articoli (selezione)',
        family: 'Famiglie di prodotto'
    },
    labels: {
        "user": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo',
            "name": 'Nome',
            "surname": 'Cognome',
            "username": 'Username',
            "email": 'Email',
            "level": 'Livello utente',
            "avatar": 'Avatar',
            "password": 'Password',
            "idCustomer": 'Cliente',
            "hideAddItemConfirm": 'Nascondi conferma aggiunta articolo (agente)'
        },
        "user_group": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome gruppo',
            "email": 'Email',
            "phone": 'Telefono'
        },
        "log": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItem": 'Id elemento',
            "idUser": 'Utente',
            "entity": 'Entità',
            "operation": 'Operazione',
            "operation.options.0_DELETE": 'Elimina',
            "operation.options.1_EDIT": 'Modifica',
            "operation.options.2_ADD": 'Aggiungi',
            "operation.options.3_LOGIN": 'Login',
            "operation.options.4_LOGOUT": 'Logout',
            "notes": 'Note',
        },
        "user_entity_saved_filters": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "name": 'Nome',
            "notes": 'Note',
            "content": 'Json filtri'
        },
        "user_entity_preferences": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "content": 'Json preferenze'
        },

        "gyv_customer": {
            "id": 'Codice Cliente',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Agente',
            "name": 'Ragione Sociale',
            "address": 'Indirizzo',
            "city": 'Città',
            "destinations": 'Destinazioni',
            "discountStd": 'Sconto standard',
            "discountExtra": 'Sconto extra',
            "paymentMethod": 'Metodo di pagamento',
            "delivery": 'Consegna',
            "shippingCharge": 'Addebito trasporto',
            "chargePercentage": 'Percentuale addebito',
            "unsolved": 'Insoluto',
            "unsolved.options.N": 'No',
            "unsolved.options.S": 'Si',
            "unsolved.options.CC": 'CC',
            "zone": 'Zona',
            "phone": 'Telefono',
            "email": 'Email',
            "pec": 'Pec',
            "sdi": 'Sdi',
            "fuoriConfezione": 'Fuori confezione'
        },
        "gyv_customer_active": {
            "id": 'Codice Cliente',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Agente',
            "name": 'Ragione Sociale',
            "address": 'Indirizzo',
            "city": 'Città',
            "destinations": 'Destinazioni',
            "discountStd": 'Sconto standard',
            "discountExtra": 'Sconto extra',
            "paymentMethod": 'Metodo di pagamento',
            "delivery": 'Consegna',
            "shippingCharge": 'Addebito trasporto',
            "chargePercentage": 'Percentuale addebito',
            "unsolved": 'Insoluto',
            "unsolved.options.N": 'No',
            "unsolved.options.S": 'Si',
            "unsolved.options.CC": 'CC',
            "zone": 'Zona',
            "phone": 'Telefono',
            "email": 'Email',
            "pec": 'Pec',
            "sdi": 'Sdi'
        },
        "gyv_customer_unsolved": {
            "id": 'Codice Cliente',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Agente',
            "name": 'Ragione Sociale',
            "address": 'Indirizzo',
            "city": 'Città',
            "destinations": 'Destinazioni',
            "discountStd": 'Sconto standard',
            "discountExtra": 'Sconto extra',
            "paymentMethod": 'Metodo di pagamento',
            "delivery": 'Consegna',
            "shippingCharge": 'Addebito trasporto',
            "chargePercentage": 'Percentuale addebito',
            "unsolved": 'Insoluto',
            "unsolved.options.N": 'No',
            "unsolved.options.S": 'Si',
            "unsolved.options.CC": 'CC',
            "zone": 'Zona',
            "phone": 'Telefono',
            "email": 'Email',
            "pec": 'Pec',
            "sdi": 'Sdi'
        },
        "gyv_order": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Agente',
            "author": 'Autore',
            "idCustomer": 'id Cliente',
            "customer": 'Cliente',
            "notes": 'Note',
            "status": 'Stato',
            "status.options.0_DRAFT": 'Bozza',
            "status.options.5_WAITING": 'In accettazione',
            "status.options.10_SENT": 'In approvazione',
            "status.options.20_CONFIRMED": 'Approvato',
            "status.options.30_CANCELED": 'Annullato',
            "sendingDate": 'Data invio ordine',
            "rows": 'Righe',
            "idUser": 'Utente cliente',
            "desiredDelivery": 'Consegna a partire da',
            "isQuotation": 'Preventivo',
            "sendQuotation": 'Mandare preventivo',
            "sendOrderConfirmation": 'Mandare conferma ordine',
            "destination": 'Destinazione'
        },
        "customer_order": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Agente',
            "author": 'Utente',
            "idCustomer": 'id Cliente',
            "notes": 'Note',
            "status": 'Stato',
            "status.options.0_DRAFT": 'Bozza',
            "status.options.5_WAITING": 'In accettazione',
            "status.options.10_SENT": 'In approvazione',
            "status.options.20_CONFIRMED": 'Approvato',
            "status.options.30_CANCELED": 'Annullato',
            "sendingDate": 'Data invio ordine',
            "rows": 'Righe',
            "idUser": 'Utente cliente',
            "desiredDelivery": 'Consegna a partire da',
            "isQuotation": 'Preventivo',
            "sendQuotation": 'Mandare preventivo',
            "sendOrderConfirmation": 'Mandare conferma ordine',
            "destination": 'Destinazione',
            "customerOrderCode": 'Rif ordine cliente'
        },
        "order_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "sku": 'Codice trivek',
            "supplierSku": 'Codice originale',
            "name": 'Nome articolo',
            "quantity": 'Quantità',
            "price": 'Prezzo',
            "discountStd": 'Sconto Std',
            "discount": 'Extra',
            "gift": 'Omaggio',
            "gift.options.Normale": 'Normale',
            "gift.options.Omaggio": 'Omaggio',
            "fuoriConfezione": 'Fuori Conf',
            "notes": 'Note'
        },
        "gyv_customer_history": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "invoiceDate": 'Data fattura',
            "idCustomer": 'Codice cliente',
            "customerName": 'Cliente',
            "sku": 'Codice Trivek',
            "supplierSku": 'Codice originale',
            "name": 'Nome articolo',
            "quantity": 'Quantità',
            "price": 'Prezzo',
            "discount": 'Sconto',
            "netPrice": 'Netto'
        },
        "gyv_customer_rimanenze": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "invoiceDate": 'Data fattura',
            "idCustomer": 'Codice cliente',
            "customerName": 'Cliente',
            "sku": 'Codice Trivek',
            "supplierSku": 'Codice originale',
            "name": 'Nome articolo',
            "quantity": 'Quantità',
            "price": 'Prezzo',
            "discount": 'Sconto',
            "netPrice": 'Netto',
            "residuo": 'Residuo'
        },
        "gyv_item": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "sku": 'Codice Trivek',
            "supplierSku": 'Codice originale',
            "name": 'Nome articolo',
            "quantity": 'Quantità',
            "price2": 'Prezzo',
            "outOfStock": 'Esaurito',
            "detail": 'Dettaglio'
        },
        "gyv_item_picker": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "sku": 'Codice Trivek',
            "supplierSku": 'Codice originale',
            "name": 'Descrizione',
            "price": 'Prezzo',
            "quantity": 'Disponibilità',
            "package": 'Delta confezione',
            "promo": 'Promo'
        },
        "family": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "sigla": 'Sigla',
            "nome": 'Nome',
            "capitolo": 'Capitolo',
            "significato": 'Significato'
        }
    }
};